module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola-top-movie-0891d0375f90fcc9f9c2f3c4b36c1248.jpg";